export default "__VITE_ASSET__itSXuuGL__"